<template>
    <div class="horizontalScreen" type="false">
        <headers></headers>
        <div class="main">
            <div class="login">
                <p>
                    <span :style="{width:$i18n.locale=='zh'?'60px':'120px'}">{{$t('signUp').email.title}} ：</span>
                    <input class="input" type="text" name="email" v-model="email" :placeholder="$t('signUp').email.placeholder">
                </p>
                <p>
                    <span :style="{width:$i18n.locale=='zh'?'60px':'120px'}">{{$t('signUp').password.title2}} ：</span>
                    <input class="input" type="password" name="password" v-model="password" :placeholder="$t('signUp').password.placeholder">
                </p>
                <p class="login_btn" style="margin-bottom:0" @click="submit">{{$t('login').title}}</p>
                <p class="toRegister">
                    <b @click="path" data-path="password" class="register">{{$t('login').password}}</b>
                    <b @click="path" data-path="signUp">{{$t('login').toRegister}}</b>
                </p>
            </div>
        </div>
        <div class="footer">Copyright 2021 mi.com . All Rights Reserved. 京ICP备18018739号-1</div>
        <div class="toast" v-show="toastShow">
            {{toastText}}
        </div>
    </div>
</template>

<script>
    import headers from "../../components/headers.vue"
    export default {
        components: {
            headers
        },
        name: 'pclogin',
        data() {
            return {
                lang: "",
                email: "",
                password: "",
                toastShow: false,
                click: true,
                toastText: '',
                reg: /^1[3456789]\d{9}$/,
                verify: /(\S)+[@]{1}(\S)+[.]{1}(\w)+/,
            }
        },
        created() {
            let lang = localStorage.getItem("lang");
            this.$i18n.locale = this.lang = lang;
        },
        mounted() {

        },
        methods: {
            path(e) {
                let that = this,
                    path = e.target.dataset.path;
                that.$router.replace('/pc/' + path).catch(() => {})
            },
            submit() {
                let that = this,
                    data = new FormData();
                if (that.click) {
                    that.click = false;
                    if (that.email == "") {
                        that.toast(that.$t('signUp').email.placeholder)
                        return
                    } else if (!(that.verify.test(that.email))) {
                        that.toast(that.$t('signUp').email.error)
                        return
                    } else if (that.password == "") {
                        that.toast(that.$t('signUp').password.placeholder)
                        return
                    } else if (that.password.length < 6) {
                        that.toast(that.$t('signUp').password.error)
                        return
                    } else if (that.password1 == "") {
                        that.toast(that.$t('signUp').password1.placeholder)
                        return
                    } else {
                        data.append('account', that.email);
                        data.append('password', that.password);
                        that.rq.post("/user/login", data).then(res => {
                            console.log(res.data)
                            if (res.code == '1') {
                                that.toast(that.$t('login').success)
                                localStorage.setItem('sign',res.data.userinfo.audit_status)
                                localStorage.setItem("token", res.data.userinfo.token)
                                localStorage.setItem("email", res.data.userinfo.username)
                                localStorage.setItem("adjust", res.data.userinfo.adjust)

                                setTimeout(() => {
                                    that.$router.replace('/pc/personal').catch(() => {})
                                }, 1400)
                            } else if (res.code == '0') {
                                that.toast(that.$t('login').please_register)
                                return
                            }
                        })
                    }
                }
            },
            toast(str) {
                let that = this
                that.toastText = str
                that.toastShow = true
                setTimeout(function() {
                    that.toastShow = false
                    that.click = true;
                }, 1500)
            },
        }
    }
</script>
<style scoped>
    .toRegister {
        width: 380px;
        padding-top: 0;
        margin: 0 auto 50px!important;
        text-align: right;
        justify-content: space-between;
    }
    
    .toRegister>b {
        border-bottom: none!important;
        margin: 0 0;
    }
</style>


// WEBPACK FOOTER //
// src/views/pc/login.vue